/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.M = global.M = require('materialize-css');

import Vue from 'vue'

import Swiper from 'swiper';
import vuetify from '@/plugins/Vuetify';

import VueI18n from 'vue-i18n'
window.locomotive = require('locomotive-scroll').default;

window.Swiper = global.Swiper = Swiper;

global.moment = window.moment = require('moment').default;

global.firebase = window.firebase = require('firebase').default;

require('firebase/auth');

Vue.component('languageSwitcher', require('./components/language-switcher.vue').default);

//WEBSITE COMPONENTS
Vue.component('navbar', require('./components/website/nav.vue').default);

global.firebaseui = window.firebaseui = require('firebaseui');
// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDouBBiBBRdGILl7UM0GQt3yYHxPFLsvrA",
  authDomain: "brartist-c47d3.firebaseapp.com",
  databaseURL: "https://brartist-c47d3.firebaseio.com",
  projectId: "brartist-c47d3",
  storageBucket: "brartist-c47d3.appspot.com",
  messagingSenderId: "1085462696311",
  appId: "1:1085462696311:web:9e84cb3a3fb26074be9172"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.use(VueI18n)

new Vue({
  vuetify
}).$mount('#app')  